import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import moment from 'moment';
moment.locale("en");
type Props = {
  title: string;
  subtitle: string;
  percent: number; // ex: 45.9
  maxLabel: string;
};

const FollowerProgressCard: React.FC<Props> = ({ title, subtitle, percent, maxLabel }) => {
  
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // animação suave ao montar
    const timeout = setTimeout(() => {
      setProgress(percent);
    }, 100);

    return () => clearTimeout(timeout);
  }, [percent]);

  return (
    <Card className="card p-3 justify-content-center" style={{ maxWidth: '500px' , height: '250px'}}>
      <div className="d-flex justify-content-between align-items-center">
        <div>
          {/*  mostrar data em ingles com o moment */}
          <h6 className="mb-0 fw-bold">{title} ({moment().add(-1,"month").format('MMMM YYYY')}) </h6>
          <small className="text-muted">{subtitle}</small>
        </div>
        <div className=" fw-bold fs-4">{percent.toFixed(1).replace('.', ',')}%</div>
      </div>

      <div className="progress mt-3" style={{ height: '18px', borderRadius: '4px' }}>
        <div
          className="progress-bar"
          role="progressbar"
          style={{
            width: `${progress}%`,
            background: `linear-gradient(to right, #7de9b9, #2ecc71)`,
            transition: 'width 1s ease-in-out',
          }}
        ></div>
      </div>

      <div className="d-flex justify-content-between mt-1">
        <small className="text-muted">0</small>
        <small className="text-muted">{maxLabel}</small>
      </div>
    </Card>
  );
};

export default FollowerProgressCard;
